<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import ActivityComponent from './ActivityComponent.vue'

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, oldDueDate, newDueDate } = this.activity
      const creator = user.uuid === this.self.uuid ? this.$t('You') : user.name
      const action = oldDueDate ? 'changed' : 'set'

      return `${creator} ${action === 'changed' ? `changed the due date from <strong>${this.FORMAT_DATE(oldDueDate, 'Do MMM YYYY')}</strong> to <strong>${this.FORMAT_DATE(newDueDate, 'Do MMM YYYY')}</strong>` : `set the due date to <strong>${this.FORMAT_DATE(newDueDate, 'Do MMM YYYY')}</strong>`} for this task.`
    },
  },
}
</script>
